import {Component, Input} from '@angular/core';
import {CampaignWithPreviewDTO} from 'src/app/services/api/api';
import {UtilService} from 'src/app/services/util.service';

@Component({
  selector: '[sb-campaign-preview-slider]',
  templateUrl: './sb-campaign-preview-slider.component.html',
  styleUrls: ['./sb-campaign-preview-slider.component.scss'],
  standalone: false,
})
export class SbCampaignPreviewSliderComponent {
  _campaigns;
  @Input() set campaigns(val: CampaignWithPreviewDTO[]) {
    this._campaigns = val;
  }

  get campaigns(): CampaignWithPreviewDTO[] {
    return this._campaigns;
  }

  @Input() companyId: number;

  constructor(public util: UtilService) {}
}
